import script from "./CartList.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartList.vue?vue&type=script&lang=ts&setup=true"

import "./CartList.vue?vue&type=style&index=0&id=abcc65a0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Arco\\Documents\\Git\\unifix\\unifix-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abcc65a0"]])

export default __exports__